<div class="p-6">
  @if (loading) {
    <div class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
    </div>
  }

  @if (error) {
    <div class="mb-4 p-3 rounded-lg bg-error-50 border border-error-200 text-sm text-error-700 dark:bg-error-500/10 dark:border-error-500/20 dark:text-error-400">
      {{ error }}
    </div>
  }

  @if (!loading) {
    <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
      @if (currentIsSystem) {
        <div class="p-3 rounded-lg bg-warning-50 border border-warning-200 text-sm text-warning-700 dark:bg-warning-500/10 dark:border-warning-500/20 dark:text-warning-400">
          Este estado es del sistema. El nombre no puede modificarse y no podrá eliminarse.
        </div>
      }

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Nombre interno <span class="text-error-500">*</span>
          </label>
          <input type="text" formControlName="name" placeholder="Ej: scheduled"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 disabled:opacity-60 disabled:cursor-not-allowed"
            [class.border-error-500]="hasError('name')"
            [class.border-gray-300]="!hasError('name')" />
          @if (hasError('name')) {
            <p class="mt-1.5 text-sm text-error-500">{{ getError('name') }}</p>
          }
        </div>
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Etiqueta <span class="text-error-500">*</span>
          </label>
          <input type="text" formControlName="label" placeholder="Ej: Agendado"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            [class.border-error-500]="hasError('label')"
            [class.border-gray-300]="!hasError('label')" />
          @if (hasError('label')) {
            <p class="mt-1.5 text-sm text-error-500">{{ getError('label') }}</p>
          }
        </div>
      </div>

      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Descripción</label>
        <textarea formControlName="description" rows="2" placeholder="Descripción del estado (opcional)"
          class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"></textarea>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Color</label>
          <input type="color" formControlName="color"
            class="h-11 w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 cursor-pointer" />
        </div>
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Orden</label>
          <input type="number" formControlName="sortOrder"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
        </div>
      </div>

      <div class="flex items-center gap-3">
        <input id="isFinal" type="checkbox" formControlName="isFinal"
          class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500" />
        <label for="isFinal" class="text-sm text-gray-700 dark:text-gray-300">Es estado final (ej: completado, cancelado)</label>
      </div>

      <div class="flex items-center gap-3">
        <input id="isDefault" type="checkbox" formControlName="isDefault"
          class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500" />
        <label for="isDefault" class="text-sm text-gray-700 dark:text-gray-300">Es estado por defecto</label>
      </div>

      <div class="flex items-center gap-3">
        <input id="statusIsActive" type="checkbox" formControlName="isActive"
          class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500" />
        <label for="statusIsActive" class="text-sm text-gray-700 dark:text-gray-300">Activo</label>
      </div>

      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
        <app-button variant="primary" type="submit" [disabled]="saving || form.invalid">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
        </app-button>
      </div>
    </form>
  }
</div>
